import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import HoneyBem from '../../../../packages/honey-bem/honey-bem.js';
import { HeaderNavigationPropTypes } from './header-navigation-proptypes.js';
import styles from '../../header2.js';

var bemNav = HoneyBem('header-nav', styles);
var bemSubNav = HoneyBem('header-subnav', styles);
var HeaderNavigation = function HeaderNavigation(_ref) {
  var navigation = _ref.navigation,
      extraClasses = _ref.extraClasses;
  var items = navigation.length && navigation.map(function (_ref2) {
    var content = _ref2.content,
        href = _ref2.href,
        current = _ref2.current,
        RouterLink = _ref2.RouterLink,
        children = _ref2.children,
        key = _ref2.key,
        rest = _objectWithoutProperties(_ref2, ["content", "href", "current", "RouterLink", "children", "key"]);

    return (
      /* eslint-disable no-shadow */
      // I know what I'm doing
      React.createElement("li", {
        className: children ? bemNav.e('item', 'has-subnav') : bemNav.e('item'),
        key: key || content
      }, !children && (RouterLink ? React.createElement(RouterLink, _extends({
        to: href,
        className: bemNav.e('link'),
        activeClassName: bemNav.e('link', {
          active: true
        })
      }, rest), content) : React.createElement("a", _extends({
        className: bemNav.e('link', {
          active: current
        }),
        href: href
      }, rest), content)), children && React.createElement("span", _extends({
        className: bemNav.e('link', {
          active: current
        })
      }, rest), content), children && React.createElement("ul", {
        className: bemSubNav.b(false, extraClasses)
      }, children.map(function (_ref3) {
        var content = _ref3.content,
            href = _ref3.href,
            current = _ref3.current,
            key = _ref3.key,
            RouterLink = _ref3.RouterLink,
            res = _objectWithoutProperties(_ref3, ["content", "href", "current", "key", "RouterLink"]);

        return React.createElement("li", {
          className: bemSubNav.e('item'),
          key: key || content
        }, RouterLink ? React.createElement(RouterLink, _extends({
          to: href,
          className: bemSubNav.e('link'),
          activeClassName: bemSubNav.e('link', {
            active: true
          })
        }, res), content) : React.createElement("a", _extends({
          className: bemSubNav.e('link', {
            active: current
          }),
          href: href
        }, res), content));
      })))
    );
  }) || React.createElement("li", null);
  return React.createElement("ul", {
    className: bemNav.b(false, extraClasses)
  }, items);
};
HeaderNavigation.defaultProps = {
  extraClasses: '',
  navigation: []
};
HeaderNavigation.propTypes = {
  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Array used to construct the navigation, has following structure:
   * {
   *    content - defines link text
   *    href - specifies link URL
   *    current - defines if this item is the current active one
   *    RouterLink - pass custom RouterLink if you need support for ReactRouter or similar libraries
   *    children - subnavigation menu items, array with the same structure should be provided
   * }
   */
  navigation: HeaderNavigationPropTypes
};

export { HeaderNavigation };
